import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
var _excluded = ["className", "bordered", "noRowBorder", "noBorder", "pagination", "expandable"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable complexity */
import React, { useContext, useMemo } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import classNames from 'classnames';
import { customPaginationProps } from '@osui/pagination';
import { useBrandContext } from '@osui/brand-provider';
import { IconDownOutlined, IconRightOutlined } from '@osui/icons';
import Button from '@osui/button';
import 'antd/es/table/style';
import '@osui/pagination/lib/index.less';
import AntdTable from './antd-table';
import './index.less';
import './patch.less';
var clsPrefix = 'osui-table';

var paginationPosition = function paginationPosition(position) {
  if (position !== null && Array.isArray(position)) {
    var topPos = position.find(function (p) {
      return p.includes('top');
    });
    var bottomPos = position.find(function (p) {
      return p.includes('bottom');
    }); // 已知bug：当top和bottom一起出现的时候，top会覆盖bottom，因为antd是单独渲染的，现在渲染的是同一个

    if (topPos) {
      return topPos.toLowerCase().replace('top', '');
    }

    if (bottomPos) {
      return bottomPos.toLowerCase().replace('bottom', '');
    }
  }

  return 'right';
}; // Record的用法是因为用object报错提示
// 用于控制expandable


var expandableConfig = function expandableConfig() {
  var _expandable$expandIco;

  var expandable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread({}, expandable), {}, {
    columnWidth: '12px',
    expandIcon: (_expandable$expandIco = expandable.expandIcon) !== null && _expandable$expandIco !== void 0 ? _expandable$expandIco : function (_ref) {
      var expanded = _ref.expanded,
          onExpand = _ref.onExpand,
          record = _ref.record,
          expandable = _ref.expandable;

      // 参考 rc-table 的判断
      // https://github.com/react-component/table/blob/e0bab6985a67ddb11affd056dd5cbb0503f671f4/src/Body/BodyRow.tsx#L80
      if (!expandable) {
        return;
      }

      return expanded ? /*#__PURE__*/React.createElement(IconDownOutlined, {
        className: "".concat(clsPrefix, "-icloud-expandableIcon"),
        // eslint-disable-next-line react/jsx-no-bind
        onClick: function onClick(e) {
          return onExpand(record, e);
        }
      }) : /*#__PURE__*/React.createElement(IconRightOutlined, {
        className: "".concat(clsPrefix, "-icloud-expandableIcon"),
        // eslint-disable-next-line react/jsx-no-bind
        onClick: function onClick(e) {
          return onExpand(record, e);
        }
      });
    }
  });
};

function Table(_ref2, ref) {
  var className = _ref2.className,
      bordered = _ref2.bordered,
      _ref2$noRowBorder = _ref2.noRowBorder,
      noRowBorder = _ref2$noRowBorder === void 0 ? false : _ref2$noRowBorder,
      _ref2$noBorder = _ref2.noBorder,
      noBorder = _ref2$noBorder === void 0 ? false : _ref2$noBorder,
      pagination = _ref2.pagination,
      expandable = _ref2.expandable,
      props = _objectWithoutProperties(_ref2, _excluded);

  var _useBrandContext = useBrandContext(),
      brand = _useBrandContext.brand;

  var _useContext = useContext(_ConfigProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var antPrefix = getPrefixCls('table'); // antd的bordered只控制column的border，当noBorder=true时，所有border都没有，包括头部
  // 当noRowBorder时，保留头部border，没有row的border

  var internalBordered = noBorder === true ? false : bordered;
  var internalClassNames = classNames(clsPrefix, className, _defineProperty({}, "".concat(clsPrefix, "-no-row-border"), noRowBorder), _defineProperty({}, "".concat(clsPrefix, "-no-border"), noBorder), // icloud-patch
  _defineProperty({}, "".concat(clsPrefix, "-icloud"), brand === 'icloud')); // ==================== pagination ====================
  // 允许传入null

  var innerPagination = useMemo(function () {
    if (!(pagination === false || pagination === null)) {
      return _objectSpread(_objectSpread({}, pagination), {}, {
        className: classNames("".concat(antPrefix, "-pagination"),
        /* eslint-disable-next-line max-len */
        "".concat(antPrefix, "-pagination-").concat(paginationPosition(pagination && pagination.position || ['bottomRight'])), 'osui-pagination', pagination && pagination.className),
        itemRender: customPaginationProps(brand).itemRender,
        locale: customPaginationProps(brand).locale,
        showQuickJumper: {
          goButton: /*#__PURE__*/React.createElement(Button, {
            className: "osui-pagination-go-button",
            size: props.size,
            disabled: pagination === null || pagination === void 0 ? void 0 : pagination.disabled
          }, "Go")
        }
      });
    }

    return pagination;
  }, [pagination, antPrefix, brand, props.size]); // ==================== expandable ====================

  var _props$childrenColumn = props.childrenColumnName,
      childrenColumnName = _props$childrenColumn === void 0 ? 'children' : _props$childrenColumn; // 判断是不是treeData，ref：https://github.com/ant-design/ant-design/blob/master/components/table/Table.tsx#L167

  var expandType = useMemo(function () {
    var rawData = props.dataSource || [];

    if (rawData.some(function (item) {
      return item === null || item === void 0 ? void 0 : item[childrenColumnName];
    })) {
      return 'nest';
    }

    if (props.expandedRowRender || expandable && expandable.expandedRowRender) {
      return 'row';
    }

    return null;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [props.dataSource, childrenColumnName]);
  var innerExpandable = useMemo(function () {
    if (brand === 'icloud') {
      if (expandable || expandType === 'nest') {
        return expandableConfig(expandable);
      }
    }

    return expandable;
  }, [expandable, brand, expandType]);
  return /*#__PURE__*/React.createElement(AntdTable, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: internalClassNames,
    bordered: internalBordered,
    pagination: innerPagination,
    expandable: innerExpandable
  }));
}

var ForwardTable = /*#__PURE__*/React.forwardRef(Table);
hoistNonReactStatics(ForwardTable, AntdTable);
export default ForwardTable;
//# sourceMappingURL=index.js.map